module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "success theme-color"
  }, [_c('icon', {
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('span', [_vm._v("提交成功")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_vm._v("投保成功后会向您发送电子保单和承保短信")]), _vm._v(" "), (_vm.isWKB) ? _c('div', {
    staticStyle: {
      "background-color": "rgb(255, 255, 255)",
      "height": "198px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "member-jifen"
  }, [_c('p', [_vm._v("恭喜您本次获得了"), _c('span', [_vm._v(_vm._s(_vm.careValue))]), _vm._v("关爱值，"), _c('span', [_vm._v(_vm._s(_vm.points))]), _vm._v("积分")]), _vm._v(" "), _c('p', [_vm._v("奖励将在保单犹豫期后生效")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/member/forPointsList/1"
    }
  }, [_vm._v("查看奖励明细 >")])])]) : _vm._e(), _vm._v(" "), (_vm.h5 && _vm.isHH) ? _c('div', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tempHH($event)
      }
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), (!_vm.h5) ? [_c('div', {
    staticClass: "wkb"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_c('p', [_vm._v("温馨提示：")]), _vm._v(" "), _vm._l((_vm.resultNotices), function(notice, index) {
    return _c('p', {
      key: index,
      domProps: {
        "innerHTML": _vm._s((index + 1) + '、' + notice)
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lastNoticeIndex) + "、关注悟空保微信号"), _c('a', [_vm._v("iwukongbao")]), _vm._v("，点击底部“我的”菜单>个人中心，用投保手机号登录查看投保详情。")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.comment($event)
      }
    }
  }, [_vm._v("我要评价(+500积分)")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Index',
        params: {
          productCode: this.$store.state.app.productCode,
          innerCode: this.$store.state.app.innerCode
        },
        query: this.$route.query.activityCode ? '' : this.$route.query
      }
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("再次购买")])], 1), _vm._v(" "), _vm._m(1)], 1)] : _vm._e(), _vm._v(" "), _c('x-dialog', {
    staticClass: "detail-dialog",
    attrs: {
      "dialog-style": {
        width: '90%',
        'max-width': '375px'
      }
    },
    model: {
      value: (_vm.showAct),
      callback: function($$v) {
        _vm.showAct = $$v
      },
      expression: "showAct"
    }
  }, [_c('div', {
    staticClass: "result__act-main"
  }, [_c('div', {
    staticClass: "result__act-head"
  }, [_c('img', {
    staticStyle: {
      "width": "82px"
    },
    attrs: {
      "src": "static/common/images/act_poster_header_logo.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "24px"
    },
    attrs: {
      "src": "static/common/images/act_poster_header_close.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showAct = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "15px"
    }
  }, [_c('p', {
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("感谢您，我们将额外拿出"), _c('span', {
    staticStyle: {
      "color": "#FB5D2F"
    }
  }, [_vm._v("1%")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("捐赠给“大病医保”公益项目")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_c('img', {
    staticClass: "response result__act-poster",
    attrs: {
      "src": _vm.actURL,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result__act-bottom"
  }, [_c('p', {
    staticStyle: {
      "font-size": "18px",
      "color": "#333333",
      "font-weight": "bold"
    }
  }, [_vm._v("长按海报保存，分享爱心")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "8px",
      "margin-bottom": "5px"
    }
  }, [_vm._v("让更多人关注贫困儿童医疗")])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wkb-wx"
  }, [_c('img', {
    attrs: {
      "src": "static/common/images/wkb_wx.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("更多爆款产品，请关注悟空保微信号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("悟空保客服热线："), _c('a', {
    attrs: {
      "id": "tel-ask-about",
      "href": "tel:400-661-2992"
    }
  }, [_vm._v("400-661-2992")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15b805b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = 651
// module chunks = 1